import React from "react";
import './footer.css';

function Footer(){
    return(
    <>
    <footer>
        <div className="footer text-center" >
            <hr/>
            <p> Copyright © 2023    TOASTIE+CAFÉ  ■  Web Design: fpsingcak@gmail.com </p>
            
        </div>    
    </footer>
    </>
        
    )
};

export default Footer;

    